import { render, staticRenderFns } from "./FilterColumn.vue?vue&type=template&id=c0764b48&scoped=true"
import script from "./FilterColumn.vue?vue&type=script&lang=js"
export * from "./FilterColumn.vue?vue&type=script&lang=js"
import style0 from "./FilterColumn.vue?vue&type=style&index=0&id=c0764b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0764b48",
  null
  
)

export default component.exports